import React from 'react'

import styles from './SubmitBtn.module.scss'

type Props = {
	text: string
	isValid: boolean
	isSubmitting: boolean
	[key: string]: any
}

const SubmitBtn = ({ text, isValid, isSubmitting, ...rest }: Props) => {
	const isDisabled = !isValid || isSubmitting

	return (
		<button {...rest} className={isDisabled ? styles.disabled : styles.submit} disabled={isDisabled}>
			<div className={styles.text}>{text}</div>
		</button>
	)
}

export default SubmitBtn
